import { Button } from "@blueprintjs/core"
import styled from "@emotion/styled"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"
import { MediumText } from "../../../../styled/text.styled"

export const RowContainer = styled(FlexContainer)({
  margin: "0 10px",
})

export const SelectContainer = styled(FlexContainer)({
  width: "250px",
})

export const SuggestLabel = styled(MediumText)({
  width: "180px",
})

export const SelectLabel = styled(MediumText)({
  width: "120px",
})
